import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/**
 * Bouclier / permissions — distinct de VerifiedIcon (qui a un check).
 * Pour roles, securite generique sans verification d'identite.
 */
export const ShieldIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Bouclier rempli menthe */}
      <path
        d="M12 3l8 3v6c0 4.5-3.5 8-8 9.5C8.5 20 5 16.5 5 12V6l7-3z"
        fill="var(--equiply-icon-bg)" fillOpacity="0.6"
      />
      {/* Contour */}
      <path
        d="M12 3l8 3v6c0 4.5-3.5 8-8 9.5C8.5 20 5 16.5 5 12V6l7-3z"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Ligne centrale (séparation héraldique stylisée) */}
      <path
        d="M12 7v9"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
ShieldIcon.displayName = "ShieldIcon";
